// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3gVQc","footer":"ModalError_footer__22jMI"};